export * from './MSTeamsIcon';
